import React, {useState, useEffect} from 'react';
import Chart from 'react-apexcharts';
import Title from '../../../components/Title';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import {
  Button,
  CircularProgress,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import DrawTable from '../../../components/DrawTable';
import DataCard from './DataCard';
import {
  AnnotationsMonth,
  AnnotationsPremiums,
  getMonthName,
  getPlanName,
  months,
  premiuns,
  responsive,
  responsiveCards,
  responsiveMedium,
  returnTotalValues,
  returnTotalValuesPremium,
  returnValuesPremium,
  returnValuesTotalPremium,
} from '../service/utils';
import dashboardService from '../service';
import {KeyboardDatePicker} from '@material-ui/pickers';
import DrawTableDash from '../../../components/DrawTableDash';
import {GetAppOutlined} from '@material-ui/icons';
import ScreensItem from './access_charts/ScreensItem';
import CategoriesItem from './access_charts/CategoriesItem';
import SubCategoriesItem from './access_charts/SubCategoriesItem';
import TopContentItem from './access_charts/TopContentItem';
import TopPartnersItem from './access_charts/TopPartnersItem';
import ObjectivesItem from './access_charts/ObjectivesItem';

const styles = {
  margin: {
    marginTop: 15,
    marginBottom: 15,
  },
  containerCards: {
    display: 'flex',
    flexWrap: 'wrap',
    marginTop: 15,
    marginBottom: 20,
  },
  viewCharts: {
    display: 'flex',
    flexWrap: 'nowrap',
    marginTop: 15,
  },
  containerChart: {
    minWidth: '25%',
    border: 'solid 1px #d3d3d3',
    padding: 10,
    margin: '0 10px 10px 0',
  },
  containerChartDonut: {
    width: '50%',
    border: 'solid 1px #d3d3d3',
    padding: 10,
    margin: '0 10px 10px 0',
  },
  card: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  containerChartLine: {
    width: '75%',
    border: 'solid 1px #d3d3d3',
    padding: 10,
    marginTop: 20,
  },
  containerChartTable: {
    width: '75%',
    padding: 10,
    marginTop: 20,
  },
  containerChartf: {
    minWidth: '25%',
    width: '40%',
    border: 'solid 1px #d3d3d3',
    marginTop: 20,
    marginBottom: 20,
    padding: 10,
  },
  title: {textAlign: 'center', marginTop: 10, marginBottom: 10},
  flexEnd: {width: '100%', display: 'flex', justifyContent: 'flex-end'},
  datePicker: {
    borderRadius: '40px',
    height: 50,
    width: 'fit-content',
    border: 'solid 1px #d3d3d3',
    marginBottom: 20,
    marginLeft: 5,
  },
  legend: {
    width: '100%',
    display: 'flex',
    justifyContent: 'center',
    fontWeight: 'bold',
  },
};

const ScreenAccessChart = () => {
  return (
    <div style={styles.margin}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
          marginRight: 50,
        }}>
        <Typography variant="h5" color="inherit" noWrap style={styles.title}>
          Dashboard de Conteúdo
        </Typography>
      </div>

      <ScreensItem />
      <CategoriesItem />
      <SubCategoriesItem />
      <ObjectivesItem />
      <TopContentItem />
      <TopPartnersItem />
    </div>
  );
};

export default ScreenAccessChart;
